
import { Dialog, DialogContent } from "@/components/ui/dialog";

interface FullscreenDialogProps {
  imageUrl: string | null;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

export function FullscreenDialog({
  imageUrl,
  isOpen,
  onOpenChange
}: FullscreenDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-4xl max-h-[90vh] p-0 overflow-auto">
        {imageUrl && (
          <img 
            src={imageUrl} 
            alt="Fullscreen view" 
            className="w-full h-auto"
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
